// promiseTypeSuffixes for redux-promise-middle-ware
export const PROMISE_TYPE_SUFFIXES = ['PENDING', 'FULLFILLED', 'REJECTED'];
export const [PENDING, FULLFILLED, REJECTED] = PROMISE_TYPE_SUFFIXES;
// IMPERSONATE
export const STOP_IMPERSONATE = 'STOP_IMPERSONATE';
export const FETCH_IMPERSONATE_USER_LIST = 'FETCH_IMPERSONATE_USER_LIST';
export const SET_MODAL_STATE = 'IS_MODAL_OPEN';
export const CALL_PASS_THROUGH = 'CALL_PASS_THROUGH';
export const GET_COUNTRY_LIST = 'GET_COUNTRY_LIST';
export const GET_STATE_LIST = 'GET_STATE_LIST';
// INSTITUTION
export const FETCH_INSTITUTION_AFFLIATIONS = 'FETCH_INSTITUTION_AFFLIATIONS';
export const FETCH_INSTITUTION_ADDRESS_DATA = 'FETCH_INSTITUTION_ADDRESS_DATA';
export const FETCH_INSTITUTION_CONTACTS_DATA = 'FETCH_INSTITUTION_CONTACTS_DATA';
export const SAVE_SELECTED_INSTITUTION_DATA = 'SAVE_SELECTED_INSTITUTION_DATA';
export const FETCH_INSTITUTION_PROVIDERS_DATA = 'FETCH_INSTITUTION_PROVIDERS_DATA';
export const FETCH_INSTITUTION_SITE_RESTRICTIONS_DATA = 'FETCH_INSTITUTION_SITE_RESTRICTIONS_DATA';
export const SAVE_SELECTED_INSTITUTION_PROVIDER_DATA = 'SAVE_SELECTED_INSTITUTION_PROVIDER_DATA';
export const FETCH_INSTITUTION_CREDENTILAS_DATA = 'FETCH_INSTITUTION_CREDENTILAS_DATA';
export const FETCH_INSTITUTION_ASSOCIATED_PROVIDERS_DATA = 'FETCH_INSTITUTION_ASSOCIATED_PROVIDERS_DATA';
export const FETCH_INSTITUTION_AFFILIATION_DETAILS = 'FETCH_INSTITUTION_AFFILIATION_DETAILS';
export const FETCH_INSTITUTION_TREE_DETAILS = ' FETCH_INSTITUTION_TREE_DETAILS';
export const FETCH_INSTITUTION_PACKAGE_TREE_DETAILS = 'FETCH_INSTITUTION_PACKAGE_TREE_DETAILS';
export const UPDATE_INSTITUTION_PACKAGE_TREE_DETAILS = 'UPDATE_INSTITUTION_PACKAGE_TREE_DETAILS';
export const UPDATE_USER_GROUP = 'UPDATE_USER_GROUP';
export const FETCH_INSTITUION_ATTRIBUTES = 'FETCH_INSTITUION_ATTRIBUTES';
export const FETCH_INSTITUION_REQUIRED_ATTRIBUTES = 'FETCH_INSTITUION_REQUIRED_ATTRIBUTES';
export const FETCH_INSTITUION_OPTIONAL_ATTRIBUTES = 'FETCH_INSTITUION_OPTIONAL_ATTRIBUTES';
export const FETCH_INSTITUION_ADDITIONAL_ATTRIBUTES = 'FETCH_INSTITUION_ADDITIONAL_ATTRIBUTES';
export const FIND_INSTITUTION_LOVS = 'FIND_INSTITUTION_LOVS';
export const CHECK_CLAIMABLE_INSTITUTION = 'CHECK_CLAIMABLE_INSTITUTION';
export const INSTITUTION_STATUS_LIST = 'INSTITUTION_STATUS_LIST';
export const FETCH_INSTITUTION_AFFILIATION_SUMMARY = 'FETCH_INSTITUTION_AFFILIATION_SUMMARY';
export const UPDATE_INSTITUTION_AFFILIATION_SUMMARY = 'UPDATE_INSTITUTION_AFFILIATION_SUMMARY';
export const SAVE_SELECTED_PROVIDER_DATA = 'SAVE_SELECTED_PROVIDER_DATA';
export const SET_INST_BROWSER_EDIT = 'SET_INST_BROWSER_EDIT';
export const IS_PACKAGE_CLAIMABLE = 'IS_PACKAGE_CLAIMABLE';
export const PUT_INSTITUTION_AFFILIATION = 'PUT_INSTITUTION_AFFILIATION';
export const UI_ADD_INSTITUTION_AFFILIATION = 'UI_ADD_INSTITUTION_AFFILIATION';
export const UI_RESET_INSTITUTION_AFFILIATION = 'UI_RESET_INSTITUTION_AFFILIATION';
export const UI_PUT_INSTITUTION_AFFILIATION = 'UI_PUT_INSTITUTION_AFFILIATION';
export const SAVE_INSTITUTION_JOB_ID = 'SAVE_INSTITUTION_JOB_ID';
// PERSONS
export const FETCH_PERSON_REGISTRATION_DATA = 'FETCH_PERSON_REGISTRATION_DATA';
export const SAVE_SELECTED_PERSON_DATA = 'SAVE_SELECTED_PERSON_DATA';
export const FETCH_PERSON_CONTACTS_DATA = 'FETCH_PERSON_CONTACTS_DATA';
export const FETCH_PERSON_ADDRESSES_DATA = 'FETCH_PERSON_ADDRESSES_DATA';
export const FETCH_PERSON_AFFILIATIONS = 'FETCH_PERSON_AFFILIATIONS';
export const FETCH_PERSON_SUMMARY = 'FETCH_PERSON_SUMMARY';
export const FETCH_MY_TASKS = 'FETCH_MY_TASKS';
export const FETCH_LMS_TRAINING_DATA = 'FETCH_LMS_TRAINING_DATA';
export const CALL_IMPERSONATE_USER = 'CALL_IMPERSONATE_USER';
export const SAVE_SELECTED_MEMBER_ROLE_STATUS = 'SAVE_SELECTED_MEMBER_ROLE_STATUS';
export const SAVE_SELECTED_MEMBER_ROSTER_STATUS = 'SAVE_SELECTED_MEMBER_ROSTER_STATUS';
export const FETCH_PERSON_ATTRIBUTES = 'FETCH_PERSON_REQUIRED_ATTRIBUTES';
export const FETCH_PERSON_ROSTER_ROLE_DATA = 'FETCH_PERSON_ROSTER_ROLE_DATA';
export const SET_SELECTED = 'SET_SELECTED';

// CREDENTIALINGS
export const SAVE_SELECTED_CRED_REQ_STATUS = 'SAVE_SELECTED_CRED_REQ_STATUS';
export const FETCH_CREDENTIALING_GRID_DATA = 'FETCH_CREDENTIALING_GRID_DATA';
export const FETCH_CREDENTIALING_REQUEST_DETAILS = 'FETCH_CREDENTIALING_REQUEST_DETAILS';
export const FETCH_CREDENTIALING_ADD_ROLE_DATA = 'FETCH_CREDENTIALING_ADD_ROLE_DATA';
export const FETCH_CREDENTIALING_WITHDRAW_ROLE_DATA = 'FETCH_CREDENTIALING_WITHDRAW_ROLE_DATA';
export const FETCH_CREDENTIALING_WITHDRAW_PERSON_DATA = 'FETCH_CREDENTIALING_WITHDRAW_PERSON_DATA';
export const SAVE_SELECTED_CRED_ROW_DATA = 'SAVE_SELECTED_CRED_ROW_DATA';

// ERROR
export const HANDLE_REQUEST = 'HANDLE_ERROR';

// OTHERS
export const MOCK_DATA = 'MOCK_DATA';

export const IS_MODAL_OPEN = 'IS_MODAL_OPEN';
export const IS_EDITING = 'IS_EDITING';
